import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { HeadCount, Round, TermLength } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-cerfa-length',
  templateUrl: 'cerfa-length.component.html',
  styleUrls: ['./cerfa-length.component.less', '../../../shared/common.less'],
})

export class CerfaLengthComponent implements OnInit {
  @Input() termLength: TermLength;
  @Input() headcount: HeadCount;
  @Input() round: Round;
  @Input() isValidated: boolean;
  @Output() termLengthChange = new EventEmitter<TermLength>();
  @Output() headcountChange = new EventEmitter<HeadCount>();
  @Output() numberOfCollegesChange = new EventEmitter<number>();

  constructor(
  ) { }

  validateYears() {

    if (this.termLength.duration[0] < 0) {
      this.termLength.duration[0] = 0;
    } else if (this.termLength.duration[0] > 4) {
      this.termLength.duration[0] = 4;
    }

    if (this.termLength.duration[0] == 4) {
      this.termLength.duration[1] = 0;
    }

    this.onLengthChange();
  }

  validateMonths() {
    if (this.termLength.duration[0] == 4) {
      setTimeout(() => {
        this.termLength.duration[1] = 0;
        this.onLengthChange();
      });
      return;
    } else if (this.termLength.duration[1] < 0) {
      this.termLength.duration[1] = 0;
    } else if (this.termLength.duration[1] > 11) {
      this.termLength.duration[1] = 11;
    }

    this.onLengthChange();
  }

  onLengthChange() {
    this.termLengthChange.emit(this.termLength);
  }

  onHeadcountChange() {
    this.headcountChange.emit(this.headcount);
  }

  onNumberOfCollegesChange() {
    this.onHeadcountChange()
    this.numberOfCollegesChange.emit(this.headcount.numberOfColleges);
  }

  ngOnChanges(): void {

  }

  ngOnInit(): void {
  }
}
